<template>
  <Card
    :class="$style.cardContainer"
  >
    <template v-slot:body>
      <Grid
        hasGap
      >
        <GridItem
          :gridSpan="1"
        >
          <AsideIcon
            :class="$style.icon"
            icon="user"
          />
        </GridItem>
        <GridItem
          :class="$style.details"
          :gridSpan="6"
        >
          <ParagraphBody
            :hasMargin="false"
          >
            <strong>Name:</strong>
            {{ name }}
          </ParagraphBody>
          <ParagraphBody
            :hasMargin="false"
          >
            <strong>Username:</strong>
            {{ item.username }}
          </ParagraphBody>
          <ParagraphBody
            :hasMargin="false"
          >
            <strong>Email:</strong>
            {{ item.email }}
          </ParagraphBody>
          <ParagraphBody
            :hasMargin="false"
          >
            <strong>User State:</strong>
            {{ state }}
          </ParagraphBody>
        </GridItem>
      </Grid>
    </template>
  </Card>
</template>

<script>
import {
  Card,
  Grid,
  GridItem,
  ParagraphBody,
} from '@jumpcloud/ui-components';
import { ModuleConsts } from 'client/util/Constants';
import { capitalize } from 'lodash';
import { mapGetters } from 'vuex';
import AsideIcon from 'client/components/AsidePanel/AsideIcon.vue';

const { activated, staged, suspended } = ModuleConsts.systemUser.accountStates;

export default {
  name: 'UserSummary',

  components: {
    AsideIcon,
    Card,
    Grid,
    GridItem,
    ParagraphBody,
  },

  props: {
    item: {
      type: Object,
      default: undefined,
    },
  },

  computed: {
    ...mapGetters('SystemUserCollection', ['getDisplayName']),

    name() {
      return this.getDisplayName(this.item);
    },

    state() {
      const stateMap = {
        [activated]: () => 'Active',
        [staged]: () => capitalize(staged.toLowerCase()),
        [suspended]: () => capitalize(suspended.toLowerCase()),
      };

      return stateMap[this.item.state]();
    },
  },
};
</script>

<style module scoped>
.cardContainer.cardContainer {
  margin-bottom: var(--jc-spacer-small);
}

.icon {
  --icon-size: var(--jc-size-2p25);
}

.details {
  align-self: center;
}
</style>
